import React, { useState } from 'react';

import { Formik, Field } from 'formik';
import * as Yup from 'yup';

import { forceReloadPayment, forceReloadPayments, useUpdatePayment } from '@hooks/API/UsePayments';

import { NwCancelButton, NwSaveButton } from '@components/Gui/NwButton';
import NwDrawer from '@components/Gui/NwDrawer';
import { NWInput, NWTextAreaCharCounter } from '@components/Gui/NwForm/NwFormItems';
import { NwForm, NwFormButtonsBar } from '@components/Gui/NwForm/NwFormWrapper';

const EditPaymentDrawer = ({ onClose, paymentData }) => {
    const [touchForm, setTouchForm] = useState(false);
    const { mutateAsync: onUpdatePayment } = useUpdatePayment();

    const initialValues = {
        ID: paymentData.ID,
        Name: paymentData.Name,
        HeaderNote: paymentData.HeaderNote ? paymentData.HeaderNote : '',
        AddressNote: paymentData.AddressNote ? paymentData.AddressNote : '',
        //FooterNote: paymentData.FooterNote ? paymentData.FooterNote : "",
    };

    const savePayment = async (values, setSubmitting) => {
        setSubmitting(true);
        try {
            await onUpdatePayment({
                data: { ...values },
            });
            forceReloadPayment(values.ID);
            forceReloadPayments(paymentData.ContactID);
            onClose();
        } catch (e) {
            console.error('error', e);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <NwDrawer touchForm={touchForm} onTouchForm={setTouchForm} onClose={onClose} title="Edit Payment Details">
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    savePayment(values, setSubmitting);
                }}
                validationSchema={Yup.object().shape({
                    Name: Yup.string().required('Payment Name is required'),
                })}
            >
                {({ isSubmitting, values, handleSubmit }) => (
                    <NwForm values={values} onTouchForm={setTouchForm} onFinish={handleSubmit}>
                        <Field
                            component={NWInput}
                            label="Name"
                            name="Name"
                            maxLength={50}
                            type="text"
                            value={values.Name}
                        />
                        <Field
                            component={NWTextAreaCharCounter}
                            label="Description"
                            name="HeaderNote"
                            maxLength={600}
                            type="text"
                            value={values.HeaderNote}
                        />
                        <Field
                            component={NWTextAreaCharCounter}
                            label="Address Text"
                            name="AddressNote"
                            maxLength={600}
                            type="text"
                            value={values.AddressNote}
                        />
                        {/* <Field
                            component={NWTextAreaCharCounter}
                            label="Footer Text"
                            name="FooterNote"
                            maxLength={600}
                            type="text"
                            value={values.FooterNote}
                        /> */}
                        <NwFormButtonsBar
                            left={
                                <NwCancelButton
                                    disabled={isSubmitting}
                                    onClick={() => {
                                        setTouchForm(false);
                                        onClose();
                                    }}
                                />
                            }
                            right={<NwSaveButton htmlType="submit" disabled={isSubmitting} loading={isSubmitting} />}
                        />
                    </NwForm>
                )}
            </Formik>
        </NwDrawer>
    );
};

export default EditPaymentDrawer;
